module.exports = __webpack_public_path__ + "img/admin.7b0b4d27.png";